export default __webpack_public_path__ + "static/media/Group 6512@3x.b0842081.png";